import { IconButton, InputAdornment, ListSubheader, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import Iconify from "minimals-template/components/Iconify"

/**
 * A search input component for the `ExtendedSelect` that allows filtering options
 * by text and provides a sort button to toggle sorting of the options.
 *
 * @param {Object} props - The props for the `ExtendedSelectSearch` component.
 * @param {function} props.setSearchText - A callback function to update the search text.
 * @param {function} props.setSort - A callback function to toggle the sorting state.
 * @param {boolean} props.sort - The current sorting state. `true` for sorted, `false` for unsorted.
 *
 * @returns {JSX.Element} The rendered search input component with sorting functionality.
 */
export function ExtendedSelectSearch({ setSearchText, setSort, sort }) {
    return (
        <ListSubheader>
            <TextField
                size="small"
                autoFocus
                placeholder="Search..."
                fullWidth
                onChange={setFromEvent(setSearchText)}
                onKeyDown={handleKeyDown}
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Sort alphabetically"
                                    onClick={() => setSort((sort) => !sort)}
                                    size="small"
                                    sx={{ color: sort ? "primary.main" : undefined }}
                                >
                                    <Iconify icon="tabler:sort-a-z" />
                                </IconButton>
                            </InputAdornment>
                        ),
                    },
                }}
                data-cy="extended-select-search"
            />
        </ListSubheader>
    )

    function handleKeyDown(event) {
        if (event.key !== "Escape") {
            event.stopPropagation()
        }
    }
}
